export default {
  state: {
    ListChecked: [],
    treeChecked: []
  },
  mutations: {
    setMacTreeChecked(state, value) {
      state.treeChecked = value;
    },
    deleteMacTree(state, name) {
      if (typeof name == 'object') {
        const countryName = name.countryName;
        const newTreeChecked = state.treeChecked.filter(item => {
          if (item.countryName != countryName) return item
        })
        state.treeChecked = newTreeChecked
      }
      else {
        const index = state.treeChecked.findIndex(item => {
          return item.name == name
        })
        if (index >= 0) {
          // 需要手动 去setTreeKey
          state.treeChecked.splice(index, 1)
        }
      }
    },
    macroReset(state) {
      state.treeChecked = [];
      state.ListChecked = [];
    },

    setMacroListChecked(state, value) {
      state.ListChecked = value;
    },

    deleteMacListed(state, id) {
      if (typeof id == 'object') {  
        const countryName = id.countryName;
        const newListChecked = state.ListChecked.filter(item => {
          if (JSON.parse(item).countryName != countryName) return item
        })
        state.ListChecked = newListChecked
        console.log("TCL: deleteMacListed -> state.ListChecked", state.ListChecked)
      }
      else {
        const index = state.ListChecked.findIndex(item => {
          const ObjItem = JSON.parse(item)
          return ObjItem.id == id
        })
        if (index >= 0) {
          //引用类型  state List删除了   页面中的list也删除了
          state.ListChecked.splice(index, 1)
        }
      }
    }
  }
}